<template>
  <b-col>
    <div ref="card__account-info" class="card__account-info">
      <div ref="text__account-info-title" class="h5 font-weight-bold mb-3">Account Information</div>

      <div class="block__basic-info">
        <div ref="row__basic-info-name" class="mb-2 row__basic-info">
          <b-col class="row__basic-info-title">
            <b-img
              ref="icon__info-img-name"
              class="icon__info-img"
              :src="require(`@/assets/user-profile-icons/icon-name.svg`)"
            />
            <span class="basic-info__title"> Name </span>
          </b-col>
          <b-col class="basic-info__description text__info-acc-name"
            >{{ user.firstname }} {{ user.lastname }}</b-col
          >
        </div>

        <router-link
          v-if="editable"
          ref="button__edit-name"
          class="button__edit-account-info button__edit-name"
          :to="{ name: 'profile/edit-name' }"
        >
          <b-img
            ref="icon__edit-name"
            class="icon__edit-account-info icon__edit-name"
            :src="require(`@/assets/user-profile-icons/icon-edit.svg`)"
          />
          Edit
        </router-link>
      </div>
      <div class="block__basic-info">
        <div ref="row__basic-info-email" class="mb-2 row__basic-info">
          <b-col class="row__basic-info-title">
            <b-img
              ref="icon__info-img-email"
              class="icon__info-img"
              :src="require(`@/assets/user-profile-icons/icon-email.svg`)"
            />
            <span class="basic-info__title"> Email </span>
          </b-col>
          <b-col class="basic-info__description">{{ user.email }}</b-col>
        </div>

        <div v-if="$_isFeatureEnabled('change_email')">
          <router-link
            v-if="editable && !isGoogleUser"
            ref="button__edit-email"
            class="button__edit-account-info button__edit-email"
            :to="{ name: 'profile/edit-email' }"
          >
            <b-img
              ref="icon__edit-email"
              class="icon__edit-account-info icon__edit-email"
              :src="require(`@/assets/user-profile-icons/icon-edit.svg`)"
            />
            Edit
          </router-link>
          <span
            v-else
            ref="tooltip__not-edit-email"
            v-b-tooltip.bottom.hover.v-secondary
            class="button__edit-account-info button__not-edit-email"
            tabindex="0"
            title="Cannot edit email that linked to a Google account."
          >
            <b-img
              ref="icon__edit-email"
              class="icon__edit-account-info icon__edit-email"
              :src="require(`@/assets/user-profile-icons/icon-edit.svg`)"
            />
            Edit
          </span>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { optimizelyMixin } from '@/mixins/optimizelyMixin';
export default {
  mixins: [optimizelyMixin],
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    isGoogleUser: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.card__account-info {
  background: #ffffff;
  border: 1px solid rgba(209, 210, 219, 1);
  border-radius: 12px;
  padding: 25px;
}

.button__edit-account-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3c44b1 !important;
  justify-content: flex-end;
  cursor: pointer;
}

.row__basic-info-title {
  padding: 0 !important;
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon__edit-account-info {
  width: 20px;
  height: 20px;
}

.icon__info-img {
  width: 16px;
  height: 16px;
}

.basic-info__title {
  opacity: 0.5;
  padding: 0 0 !important;
}

.row__basic-info {
  display: grid;
  align-items: start;
  grid-template-columns: 30% 70%;
  gap: 12px;
}

.row__basic-info.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.basic-info__description {
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: auto;
}
.basic-info__description.col {
  padding: 0 !important;
}

.block__basic-info {
  display: grid;
  align-items: start;
  grid-template-columns: 90% 10%;
}

@media screen and (max-width: 425px) {
  .block__basic-info {
    grid-template-columns: 70% 30%;
  }
  .row__basic-info {
    grid-template-columns: 100%;
  }
}

@media screen and (min-width: 576px) {
  .row__basic-info {
    grid-template-columns: 30% 70%;
  }
}

.button__not-edit-email {
  cursor: default;
  opacity: 0.5;
}
</style>
